module.exports = __webpack_public_path__ + "static/media/f&f.9d2c9484.jpg";